import type { CSSProperties, ReactNode } from "react";

export type SpaceToken = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12;

export interface StackProps {
  gap?: SpaceToken;
  direction?: "row" | "column";
  align?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
  wrap?: boolean;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

/**
 * Tiny flex helper so component CSS never sprinkles raw spacing
 * magic numbers (design-system §11.2).
 */
export function Stack({
  gap = 4,
  direction = "column",
  align,
  justify,
  wrap,
  as: Tag = "div",
  className,
  style,
  children,
}: StackProps) {
  return (
    <Tag
      className={className}
      style={{
        display: "flex",
        flexDirection: direction,
        gap: `var(--space-${gap})`,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? "wrap" : undefined,
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}

export function Inline(props: Omit<StackProps, "direction">) {
  return <Stack {...props} direction="row" />;
}
